import { ThemeProperties } from "./types";

const cosikaTheme : ThemeProperties = {
    name : "cosika",
    logo : {
        src : '/img/cosika-logo.png',
        alt : "Logo cosika"
    },
    gradients : {
        leftSideBarBackground : 'linear-gradient(180deg, #143426, #517160 50%, #143426 100%)',
        selectionPageBackground : 'linear-gradient(135deg, #143426 0%, #517160 100%)',
    },
    colors : {
        backButtonBackground : '#409478',
        viewItemBackground : '#426251',
        viewItemHoverBackground : '#426251ee',
        bottomPanelBackground : '#426251',
        itemContainerBackground : '#ffffff1e',
        itemContainerSelectedBackground : '#4a7c2a',
        itemContainerHoverBackground : '#5a8c3a',
        selectedBadgeBackground : '#4a7c2a',
        panoramicViewBackground : '#4262518c',
    },        
};

export default cosikaTheme;